import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function AddTitle({title, element}) {

    const location = useLocation();

    useEffect(() => {
        document.title = title;
    }, [location, title]);

    return element
}

export default AddTitle;